import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../libraries/state_reducers/store";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import AppTheme from "../../../../service/app_config/AppTheme";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { Col, Row } from "react-bootstrap";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Center from "../../../../widget/common/ui/Center";

const HomeGuestUserSocialBody = () => {
  const type: number = ResponsiveDeviceType();
  const socialLinks = useSelector(
    (state: RootState) => state.homeGuestUser.socialLinks
  );

  return (
    <Row>
      {(socialLinks ?? []).map((item, key) => (
        <Col key={key} style={{ opacity: 0.5 }} xs={3}>
          <Center>
            <IconCircleFilledIcon
              name={item.icon}
              className="mx-2 my-3"
              color={AppTheme.white}
              size={type === 1 ? undefined : 60}
              handleClick={() => UtilityHelper.navigateTab(item.link)}
            />
          </Center>
        </Col>
      ))}
    </Row>
  );
};

export default HomeGuestUserSocialBody;
